import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/users").then((module) => ({
    default: module.Users,
  })),
);

export const Route = createFileRoute("/admin/users/")({
  component: Page,
});
